import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.62 3.49',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M2.69,2.14a.69.69,0,0,1-.48-.2.55.55,0,0,0-.4-.16.55.55,0,0,0-.4.16.67.67,0,0,1-.47.2.69.69,0,0,1-.48-.2.55.55,0,0,0-.4-.16A.06.06,0,0,1,0,1.72a.06.06,0,0,1,.06-.06.69.69,0,0,1,.48.19A.53.53,0,0,0,.94,2a.57.57,0,0,0,.4-.17.66.66,0,0,1,.47-.19.69.69,0,0,1,.48.19.56.56,0,0,0,.8,0,.66.66,0,0,1,.47-.19.05.05,0,0,1,.06.06.06.06,0,0,1-.06.06.56.56,0,0,0-.4.16A.67.67,0,0,1,2.69,2.14Z"
        />
        <path
          fill={fill}
          d="M2.69,2.82a.69.69,0,0,1-.48-.2.56.56,0,0,0-.8,0,.67.67,0,0,1-.47.2.69.69,0,0,1-.48-.2.55.55,0,0,0-.4-.17A.06.06,0,0,1,0,2.39a.06.06,0,0,1,.06-.06.69.69,0,0,1,.48.2.53.53,0,0,0,.4.17.57.57,0,0,0,.4-.17.67.67,0,0,1,.47-.2.69.69,0,0,1,.48.2.56.56,0,0,0,.8,0,.67.67,0,0,1,.47-.2.06.06,0,0,1,.06.06.05.05,0,0,1-.06.06.57.57,0,0,0-.4.17A.67.67,0,0,1,2.69,2.82Z"
        />
        <path
          fill={fill}
          d="M2.69,3.49a.69.69,0,0,1-.48-.19.56.56,0,0,0-.8,0,.66.66,0,0,1-.47.19A.69.69,0,0,1,.46,3.3a.55.55,0,0,0-.4-.17A.06.06,0,0,1,0,3.07.06.06,0,0,1,.06,3a.69.69,0,0,1,.48.2.53.53,0,0,0,.4.16.56.56,0,0,0,.4-.16A.67.67,0,0,1,1.81,3a.69.69,0,0,1,.48.2.58.58,0,0,0,.8,0A.67.67,0,0,1,3.56,3a.06.06,0,0,1,.06.06.05.05,0,0,1-.06.06.57.57,0,0,0-.4.17A.66.66,0,0,1,2.69,3.49Z"
        />
        <path
          fill={fill}
          d="M.57,1.34A.47.47,0,0,1,.11.88,2.69,2.69,0,0,1,.52,0,.07.07,0,0,1,.63,0,2.7,2.7,0,0,1,1,.88.46.46,0,0,1,.57,1.34ZM.57.18a2.4,2.4,0,0,0-.33.7.33.33,0,0,0,.33.33A.33.33,0,0,0,.9.88,2.16,2.16,0,0,0,.57.18Z"
        />
        <path
          fill={fill}
          d="M1.81,1.34A.47.47,0,0,1,1.35.88,2.69,2.69,0,0,1,1.76,0a.07.07,0,0,1,.11,0,2.7,2.7,0,0,1,.4.85A.46.46,0,0,1,1.81,1.34Zm0-1.16a2.4,2.4,0,0,0-.33.7.33.33,0,0,0,.66,0A2.16,2.16,0,0,0,1.81.18Z"
        />
        <path
          fill={fill}
          d="M3.05,1.34A.47.47,0,0,1,2.59.88,2.69,2.69,0,0,1,3,0a.06.06,0,0,1,.1,0,2.49,2.49,0,0,1,.41.85A.47.47,0,0,1,3.05,1.34Zm0-1.16a2.4,2.4,0,0,0-.33.7.33.33,0,0,0,.66,0A2.16,2.16,0,0,0,3.05.18Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
